import { Color } from '@diritto/common/style/color';
import { FilledNewIconProps, NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const HomeOutlineIcon = ({ color = Color.Black, className }: NewIconProps) => (
  <svg
    className={twMerge('size-[24px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M14 15V14H13H11H10V15V20H5V9.5L12 4.25L19 9.5V20H14V15Z" stroke={color} strokeWidth="2" />
  </svg>
);

export const HomeFilledIcon = ({ color = Color.Black, className }: NewIconProps) => (
  <svg
    className={twMerge('size-[24px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M4 20V11L11.9954 4L20 11V20H14V14H10V20H4Z" fill={color} />
  </svg>
);

export const HomeIcon = ({ fill, color, className }: FilledNewIconProps) =>
  fill ? (
    <HomeFilledIcon className={className} color={color} />
  ) : (
    <HomeOutlineIcon className={className} color={color} />
  );
